import React from "react"
import { Navigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import Home from "./pages/Home.jsx"
import { linksUrl } from "./constants/enum.js";

function PrivateRoute({ children, page, authorized = false }) {

  const dispatch = useDispatch();
  const { menu, isAuthenticated } = useSelector((state) => state.auth)
  //reset dashboard tab selection set selected from outstanding tab dashboard 


  function isMenuExist() {
    const menuApp = menu.appMenu.filter(
      (menuItem) => menuItem.controller === page.name
    )
    const menuUser = menu.userMenu.filter(
      (menuItem) => menuItem.controller === page.name
    )

    if (menuApp.length > 0 && menuUser.length > 0) {
      return true
    } else {
      return false
    }
  }
//console.log(isMenuExist(),menu,page.name,"gh")

  if (!isAuthenticated) {
    return <Navigate to={linksUrl.login} replace={true} />
  } else if (!authorized & !isMenuExist()) {
    return <Home />
  }
  return children
}
export default PrivateRoute
